import { Component, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-create-touches',
  templateUrl: './create-touches.component.html',
  styleUrls: ['./create-touches.component.scss']
})
export class CreateTouchesComponent implements OnInit {

  constructor() { }

  closeTouches:boolean = false

  @Output() closeShowCreate = new EventEmitter<boolean>();

  closecreateTouches(messages:boolean){
   this.closeShowCreate.emit(messages)
 }


  ngOnInit(): void {
  }

}
